import { useEffect } from 'react';
import { subscribe, unsubscribe } from '@bynder/micro-frontend-communication';

// Mirrors an externally-applied search term into the Spotlight input.
// Used e.g. when a user clicks a "Did you mean…" suggestion on the assetbank's no-results page.
export function useSetSpotlightInputFromExternalEvent(setSearchTerm: (term: string) => void) {
	useEffect(() => {
		const onSetSearchInput = (message: { searchTerm: string }) => {
			setSearchTerm(message.searchTerm);
		};

		const handler = subscribe('spotlight-modal/set-search-input', onSetSearchInput);

		return () => {
			unsubscribe('spotlight-modal/set-search-input', handler);
		};
	}, [setSearchTerm]);
}
